export default {
  error: {
    buttons: {
      back: 'Volver',
      login: 'Volver a ingresar',
      logOut: 'Cerrar sesión',
    },
    inactive: {
      title: 'Usted a superado el tiempo y paso a estar inactivo.',
      detail: 'Eso es todo lo que sabemos.',
      message: 'Código N°',
    },
    locked: {
      title: 'Usted a superado el tiempo y paso a estar inactivo.',
      detail: 'Eso es todo lo que sabemos.',
      message: 'Código N°',
    },
    auth: {
      title: 'Ha ocurrido un error',
      detail: 'Lo sentimos, algo está saliendo mal al ingresar a cat4mro',
      message: 'Código N°',
    },
    page401: {
      title: '401 No Autorizado',
      detail: 'No tiene permiso para la URL solicitada.',
      message: 'Intente nuevamente iniciando sesión.',
    },
    page404: {
      title: '404 No Encontrado',
      detail: 'La URL solicitada no se encontró en este servidor.',
      message: 'Eso es todo lo que sabemos.',
    },
    page500: {
      title: '500 Ocurrió un problema',
      detail: 'La URL solicitada no se encontró en este servidor.',
      message: 'Eso es todo lo que sabemos.',
    },
    pageContactTechSupport: {
      title: 'Algo salió mal',
      detail: 'Póngase en contacto con soporte técnico.',
      message: 'Ellos ayudaran a solventar el problema.',
      redirect: 'Se cerrará tu sesión automaticamente en ',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/error.js